export function parseIso(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function addCalendarMonth(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const target = new Date(y, m, d);
  if (target.getDate() !== d) return new Date(y, m + 1, 0);
  return target;
}

export function addWorkingDays(iso, n) {
  const dt = parseIso(iso);
  let added = 0;
  while (added < n) {
    dt.setDate(dt.getDate() + 1);
    const day = dt.getDay();
    if (day !== 0 && day !== 6) added++;
  }
  return dt;
}

export function fmtLong(date) {
  return date.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function fmtShort(date) {
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function daysUntil(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((date - today) / 86400000);
}
